import React, {useState} from 'react';
import Table from 'react-bootstrap/Table';
import useTable from "../../hooks/useTable";
import TableFooter from "./TableFooter";
import ModalRaport from "../ModalRaport";


function TableCustom({ data, rowsPerPage }) {
    const [page, setPage] = useState(1);
    const { slice, range } = useTable(data, page, rowsPerPage);

    return (
        <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center'}}>
            <Table striped responsive>
                <thead>
                <tr>
                    <th>Date</th>
                    <th>Scraped</th>
                    <th>Recognized</th>
                    <th>Recognized From DB</th>
                    <th>Details</th>
                </tr>
                </thead>
                <tbody>
                {slice.map(item => (
                    <tr key={item.datetime}>
                        <td>{item.datetime}</td>
                        <td>{item.raport.scraped}</td>
                        <td>{item.raport.recognized}</td>
                        <td>{item.raport.recognized - item.raport.recognized_from_file}</td>
                        <td><ModalRaport data={item}/></td>
                    </tr>
                ))}
                </tbody>
            </Table>
            <TableFooter range={range} slice={slice} setPage={setPage} page={page} />
        </div>
    );
}

export default TableCustom;
